export default "__VITE_ASSET__d38fede8__"